<div class="login-page-container">
  <div class="login-card">
    <div class="login-header">
      <span class="login-title">{{ httpService.getTransation().Login }}</span>
    </div>
    <div class="login-content">
      <div class="login-value-proposition">
        <p class="login-tagline">{{ httpService.getTransation().LoginPageTagline }}</p>
        <p class="login-subtitle">{{ httpService.getTransation().LoginPageSubtitle }}</p>
        <ul class="login-features">
          <li><mat-icon class="feature-icon">cloud</mat-icon> {{ httpService.getTransation().LoginFeatureAutoSave }}</li>
          <li><mat-icon class="feature-icon">print</mat-icon> {{ httpService.getTransation().LoginFeaturePrint }}</li>
          <li><mat-icon class="feature-icon">devices</mat-icon> {{ httpService.getTransation().LoginFeatureDevices }}</li>
          <li><mat-icon class="feature-icon">palette</mat-icon> {{ httpService.getTransation().LoginFeatureUnlimited }}</li>
        </ul>
      </div>
      <div class="login-buttons-container">
        <!-- Error message display -->
        <div *ngIf="loginError" class="login-error-container">
          <mat-icon class="error-icon">error_outline</mat-icon>
          <span class="error-message">{{ loginError }}</span>
          <button *ngIf="showErrorRetry" mat-button class="retry-button" (click)="retryLogin()">
            {{ httpService.getTransation().TryAgain || 'Try Again' }}
          </button>
        </div>
        
        <!-- Loading state before Google button is ready -->
        <div *ngIf="!providersReady" class="login-loading-container">
          <mat-spinner diameter="24" class="login-spinner"></mat-spinner>
          <span class="loading-text">{{ httpService.getTransation().LoginInitializing }}</span>
        </div>
        
        <!-- Google Sign-In Button Container -->
        <!-- This div will be populated by Google Identity Services -->
        <div 
          id="google-signin-button" 
          class="google-button-wrapper"
          [class.hidden]="!providersReady"
        ></div>
        
        <!-- Login progress indicator -->
        <div *ngIf="loginInProgress" class="login-progress-container">
          <mat-spinner diameter="20"></mat-spinner>
          <span class="progress-text">{{ httpService.getTransation().LoginInProgress || 'Signing you in...' }}</span>
        </div>
        
        <div class="login-trust-indicators">
          <div class="trust-item">
            <mat-icon class="trust-icon">lock</mat-icon>
            <span>{{ httpService.getTransation().LoginSecurePrivate }}</span>
          </div>
          <div class="trust-item">
            <mat-icon class="trust-icon">credit_card_off</mat-icon>
            <span>{{ httpService.getTransation().NoCreditCardRequired }}</span>
          </div>
        </div>
        <p class="login-trial-text">{{ httpService.getTransation().LoginStartFreePatterns }}</p>
        
        <!-- One-click benefit -->
        <p class="login-one-click-text">
          <mat-icon class="one-click-icon">bolt</mat-icon>
          {{ httpService.getTransation().LoginOneClick || 'One-click sign in — no passwords needed' }}
        </p>
      </div>
    </div>
  </div>
</div>
